import { useFlowFooterStore } from '../store/flowFooterStore.js';
import type { FlowFooterBadgeDescriptor } from '../types/footer.types.js';

const FlowFooterEngine = {
  registerBadge(descriptor: FlowFooterBadgeDescriptor): void {
    useFlowFooterStore.getState().registerBadge(descriptor);
  },

  unregisterBadge(id: string): void {
    useFlowFooterStore.getState().unregisterBadge(id);
  },

  updateBadge(id: string, patch: Partial<Omit<FlowFooterBadgeDescriptor, 'id'>>): void {
    useFlowFooterStore.getState().updateBadge(id, patch);
  },

  setBadgeVisibility(id: string, visible: boolean): void {
    useFlowFooterStore.getState().setBadgeVisibility(id, visible);
  },
};

export { FlowFooterEngine };
